export default {
  name: '',
  jobTitle: '',
  logo: '',
  website: '',
  phone: '',
  address: '',
  footer:
    'CONFIDENTIALITY: This email is confidential and for the exclusive use of its addressee.',
};
